
import {request} from '@/network/request'

export function fetchList(query) {
  return request({
    url: '/gaoligong/video/getVideoHome',
    method: 'get',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/gaoligong/video',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/gaoligong/video/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/gaoligong/video/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/gaoligong/video',
    method: 'put',
    data: obj
  })
}
